export const channelsRouteBasePath = "channels";

export const channelsRouteNames = {
  root: "channels",
  details: {
    root: () => `${channelsRouteNames.root}.details`,
  },
};

export const channelsRoutes: any = {
  path: channelsRouteBasePath,
  component: () => import("@/modules/channels/views/layouts/Default.vue"),
  meta: {
    auth: true,
    scope: "channels:read",
    scrollTop: true,
  },
  children: [
    {
      path: "",
      name: channelsRouteNames.root,
      component: () => import("@/modules/channels/views/ChannelsList.vue"),
    },
    {
      path: ":channelId",
      name: channelsRouteNames.details.root(),
      component: () => import("@/modules/channels/views/ChannelDetails.vue"),
    },
  ],
};
